import { NoteType } from '@shared/enums/NoteType';
import { TaskStatusType } from '@shared/enums/TaskStatusType';
import { IUserModel } from '@shared/models/user.model';
import { IEventModel } from '@shared/models/event.model';
import { INote } from '../notes-service/notes-model';

export interface IAttendeeNotes {
    attendeeNotes: IAttendeeNote[];
}

export interface IAttendeeNoteAttendee {
    id: string;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
}

export interface IAttendeeNote {
    id: string;
    created: Date;
    value: string;
    dueDate: Date;
    isCompleted: boolean;
    taskStatusType: TaskStatusType;
    note: INote;
    event: IEventModel;
    user: IUserModel;
    attendee: IAttendeeNoteAttendee;
}

export class AttendeeNote implements IAttendeeNote {
    constructor(
        public id: string,
        public created: Date,
        public value: string,
        public dueDate: Date,
        public isCompleted: boolean,
        public taskStatusType: TaskStatusType,
        public note: INote,
        public event: IEventModel,
        public user: IUserModel,
        public attendee: IAttendeeNoteAttendee
    ) { }
}

export class AttendeeNotesFilterModel {
    public searchValue = '';
    public accountOwnerFilter: string = null;
    public userId: string = null;
    public locationDateTimeId: string = null;
    public noteId: string = null;
    public eventId: string = null;
    public attendeeId: string = null;
    public noteType: NoteType = NoteType.Undefined;
    public taskStatusType: TaskStatusType = TaskStatusType.Undefined;
    public isExport: boolean;
    public accountOwnerId?: string = null;
}

export interface IAmountOfNoteTypes {
    id: string;
    text: string;
    amount: number;
}
